// src/Blogs/Blogs.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Blogs.css";

// Assets
import imgSafety from "../assets/BlogImg/CompletedFlowerAndWall.jpeg";
import imgStandardTileFixing from "../assets/BlogImg/Materials&Tools.png";
import imgA from "../assets/BlogImg/TechnicalTraining.jpeg";

const POSTS = [
  {
    id: "project-kickoff-checklist",
    to: "/blogs/project-kickoff-checklist",
    title: "Project Kickoff Checklist: Start Right, Finish Strong",
    image: imgA,
    excerpt:
      "From scope alignment to safety briefings—essentials you need before breaking ground.",
    date: "Oct 2025",
    readTime: "4 min",
    tags: ["Leadership", "Planning"],
  },
  {
    id: "construction-safety-training-india",
    to: "/blogs/construction-safety-training-india",
    title: "Construction Safety Training in India: A Complete Guide",
    image: imgSafety,
    excerpt:
      "NEBOSH, ADIS, PDIS, BSS—top courses, a clear path to Safety Officer roles, salaries, and govt-approved options.",
    date: "Oct 2025",
    readTime: "8 min",
    tags: ["Safety", "Careers"],
  },
  {
    id: "standard-tile-fixing-procedure-floor-wall",
    to: "/blogs/standard-tile-fixing-procedure",
    title: "STANDARD TILE FIXING PROCEDURE (Floor & Wall)",
    image: imgStandardTileFixing, // use your 740×254 hero/banner
    excerpt:
      "Step-by-step guide: surface prep, adhesive mixing, tile laying, grouting, curing, cleaning & protection.",
    date: "Oct 2025",
    readTime: "7 min",
    tags: ["Tiling", "Floor & Wall", "Construction", "Quality"],
  },
];

export default function Blogs() {
  return (
    <section className="blogs-wrap">
      {/* Header */}
      <div className="blogs-header">
        <p className="blogs-kicker">INSIGHTS</p>
        <h1 className="blogs-title">
          Blogs <span className="blogs-grad">— latest from GrowMax</span>
        </h1>
        <p className="blogs-sub">
          Practical, field-tested ideas for builders, managers, and teams.
        </p>
      </div>

      {/* Cards */}
      <div className="blogs-grid">
        {POSTS.map((post) => (
          <article key={post.id} className="blog-card">
            <Link
              to={post.to}
              state={{ post }}
              className="card-link"
              aria-label={`Read: ${post.title}`}
            >
              {/* Media */}
              <div className="card-media">
                <img
                  src={post.image}
                  alt={post.title}
                  loading="lazy"
                  draggable="false"
                  // className="h-[21rem]"
                  onError={(e) => {
                    // graceful fallback if an image is missing
                    e.currentTarget.src = imgA;
                  }}
                />
                <div className="card-sheen" />
              </div>

              {/* Body */}
              <div className="card-body">
                <div className="card-meta">
                  <span>{post.date}</span>
                  <span className="dot">•</span>
                  <span>{post.readTime} read</span>
                </div>

                <h3 className="card-title">{post.title}</h3>
                <p className="card-excerpt">{post.excerpt}</p>

                {post.tags?.length > 0 && (
                  <div className="card-tags">
                    {post.tags.map((t) => (
                      <span key={t} className="card-tag">
                        {t}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}

// import React from "react";
// import { Link } from "react-router-dom";
// import "./Blogs.css";

// // Assets
// import img0 from "../assets/BlogImg/GrountingFinishingWork.jpeg";
// import img1 from "../assets/book.jpg";
// import img2 from "../assets/book.jpg";
// import img3 from "../assets/book.jpg";
// import img4 from "../assets/book.jpg";
// import img5 from "../assets/book.jpg";

// const POSTS = [
//   {
//     id: "grouting-finishing-best-practices",
//     title: "Grouting & Finishing: Best Practices for Durable Surfaces",
//     image: img0,
//     excerpt:
//       "A practical guide to grouting mix ratios, curing, and finishing workflows that stand the test of time.",
//     date: "Oct 2025",
//     readTime: "6 min",
//     tags: ["Construction", "Quality"],
//   },
//   {
//     id: "project-kickoff-checklist",
//     title: "Project Kickoff Checklist: Start Right, Finish Strong",
//     image: img1,
//     excerpt:
//       "From scope alignment to safety briefings — the essentials you need before breaking ground.",
//     date: "Oct 2025",
//     readTime: "4 min",
//     tags: ["Leadership", "Planning"],
//   },
//   {
//     id: "qa-qc-field-tips",
//     title: "QA/QC in the Field: 9 Tips to Reduce Rework",
//     image: img2,
//     excerpt:
//       "Simple inspection habits that dramatically cut defects and delays without slowing down work.",
//     date: "Sep 2025",
//     readTime: "5 min",
//     tags: ["Quality", "Process"],
//   },
//   {
//     id: "crew-communication",
//     title: "Crew Communication: Turn Briefings into Results",
//     image: img3,
//     excerpt:
//       "How to run fast standups, clarify responsibilities, and keep everyone moving in the same direction.",
//     date: "Sep 2025",
//     readTime: "3 min",
//     tags: ["Soft Skills", "Leadership"],
//   },
//   {
//     id: "site-safety-essentials",
//     title: "Site Safety Essentials Everyone Forgets",
//     image: img4,
//     excerpt:
//       "The overlooked checks that prevent injuries and protect schedules, margins, and morale.",
//     date: "Aug 2025",
//     readTime: "5 min",
//     tags: ["Safety"],
//   },
//   {
//     id: "estimating-like-a-pro",
//     title: "Estimating Like a Pro: Cost & Time You Can Trust",
//     image: img5,
//     excerpt:
//       "A quick framework for realistic estimates and how to defend them with data.",
//     date: "Aug 2025",
//     readTime: "7 min",
//     tags: ["Planning", "Finance"],
//   },
// ];

// export default function Blogs() {
//   return (
//     <section className="blogs-wrap">
//       <div className="blogs-header">
//         <p className="blogs-kicker">INSIGHTS</p>
//         <h1 className="blogs-title">
//           Blogs
//           <span className="blogs-grad"> — latest from GrowMax</span>
//         </h1>
//         <p className="blogs-sub">
//           Practical, field-tested ideas for builders, managers, and teams.
//         </p>
//       </div>

//       <div className="blogs-grid">
//         {POSTS.map((post) => (
//           <article key={post.id} className="blog-card">
//             <Link
//               to={`/blogs/${post.id}`}
//               state={{ post }}
//               className="card-link"
//               aria-label={`Read: ${post.title}`}
//             >
//               <div className="card-media">
//                 <img
//                   src={post.image}
//                   alt={post.title}
//                   loading="lazy"
//                   draggable="false"
//                 />
//                 <div className="card-sheen" />
//               </div>

//               <div className="card-body">
//                 <div className="card-meta">
//                   <span>{post.date}</span>
//                   <span className="dot">•</span>
//                   <span>{post.readTime} read</span>
//                 </div>

//                 <h3 className="card-title">{post.title}</h3>
//                 <p className="card-excerpt">{post.excerpt}</p>

//                 {post.tags?.length > 0 && (
//                   <div className="card-tags">
//                     {post.tags.map((t) => (
//                       <span key={t} className="card-tag">
//                         {t}
//                       </span>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </Link>
//           </article>
//         ))}
//       </div>
//     </section>
//   );
// }
